import React from "react";

import useMainSidebarStore from "../../../../stores/mainSidebarStore";
import BootstrapSVG from "../../../BootstrapSVG";

export default function DropdownIcon() {
  const dropdownActive = useMainSidebarStore((s) => s.userDropdownActive);

  let icon;

  if (dropdownActive) {
    icon = <BootstrapSVG iconName="chevron-up" />;
  } else {
    icon = <BootstrapSVG iconName="chevron-down" />;
  }

  return icon;
}
